import React from "react";
import useService from "./useService";
import useEditList from "./useEditList";
function useServiceWithEdit(serviceMethod, serviceConfig, editListConfig) {
    // @ts-expect-error - TS2345 - Argument of type 'Partial<Config<T>> | undefined' is not assignable to parameter of type 'Partial<Config<T[]>> | undefined'.
    const [state, load] = useService(serviceMethod, serviceConfig);
    const [newData, actions] = useEditList(state.data || [], editListConfig);
    const newState = React.useMemo(() => (Object.assign(Object.assign({}, state), { data: newData })), [newData, state]);
    return [newState, load, actions, state.data];
}
export default useServiceWithEdit;
